import Box from 'atomic/box';
import classNames from 'classnames';
import React from 'react';

import './page-section-box.scss';

interface PageSectionBoxProps {
    headerText?: string;
    className?: string;
    text?: string;
    secondText?: string;
    padding?: 'none' | 'sm' | 'md' | 'lg';
    boxView?: boolean;
    children: React.ReactNode;
}

const PageSectionBox: React.FC<PageSectionBoxProps> = ({
    headerText,
    text,
    children,
    padding = 'md',
    secondText,
    boxView,
    className
}) => (
    <Box
        className={classNames('page-section-box', className)}
        padding={padding}
    >
        {headerText && <h1 className="page-section-box__header">
            {headerText}
        </h1>}
        {text && (
            <p className="page-section-box__text">
                {text}
            </p>
        )}
        <div className={classNames({
            'page-section-box__main': true,
            'page-section-box__main--title': headerText || text,
            'page-setion-box__main--box-view': Boolean(boxView)
        })}
        >
            {secondText && (
                <div className="page-section-box__second-text">
                    {secondText}
                </div>
            )
            }
            <div className="page-section-box__container">
                {children}
            </div>
        </div>
    </Box>
);

export default PageSectionBox;
